// import { win, disableScroll, enableScroll } from '../utils'
// import gsap from 'gsap';

export const Menu = new function() {
    let menuBtn
    let closeBtn
    let navList
    const openClass = 'menu-opened'
    const hiddenMenu = document.querySelector('.tl-hidden-menu')
 
    this.init = () => {
        menuBtn = document.querySelector('.tl-menu-button')
        if(!menuBtn) return
        
        navList = hiddenMenu.querySelectorAll('.menu-item')
        closeBtn = document.querySelector('.tl-close-button')

        menuBtn.addEventListener('click', this.open)
        closeBtn.addEventListener('click', this.close)
        navList.forEach( menuItem => menuItem.addEventListener( 'click', this.close ))

        // window.addEventListener('resize', () => {
        //     this.close()
        // })
    }

    this.open = () => {
        document.querySelector('.tl-layout').classList.add(openClass)
    }
    
    this.close = () => {
        document.querySelector('.tl-layout').classList.remove(openClass)
    }

}